module.exports = __webpack_public_path__ + "media/Eurasian_Wigeon.197eebc0.mp3";